import { MenuItem as ChakraMenuItem, MenuItemProps as ChakraMenuItemProps } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { forwardRef } from 'system';

const propTypes = {
  colorScheme: PropTypes.oneOf(['default', 'destructive'])
};

export const defaultProps = {
  colorScheme: 'default'
};

export type MenuItemProps = ChakraMenuItemProps & {
  colorScheme?: 'default' | 'destructive';
};

const MenuItem = forwardRef(
  (props: MenuItemProps, ref): React.ReactElement => {
    const { sx, colorScheme, ...rest } = props;
    const MenuTheme = useMultiStyleConfig('Menu', { colorScheme, ...rest });
    return <ChakraMenuItem ref={ref} sx={mergeWith(MenuTheme.item, sx)} {...rest} />;
  }
);

MenuItem.displayName = DisplayNames.MenuItem;
MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

export default MenuItem;
